import { useSelector } from 'react-redux';
import MenuListItem from './MenuListItem';
import { staticComponentValueConverter } from '../StaticComponentValues';

const MenuList_2 = ({ item }) => {
  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const customization = staticComponentValueConverter(item?.customization);
  return (
    <>
      {customization?.items?.length > 0 ? (
        <div
          style={{
            padding: `${customization?.containerPadding}`,
            backgroundColor: customization?.backgroundType === 'backgroundColor' ? customization?.backgroundColor : '',
            backgroundImage:
              customization?.backgroundType === 'backgroundImage' ? `url(${customization?.backgroundImage})` : '',
          }}
        >
          <div>
            <MenuListItem data={customization?.items} customization={customization} index={0} />
          </div>
        </div>
      ) : (
        <img src={item?.placeholderImage} className={` w-full `} />
      )}
    </>
  );
};

export default MenuList_2;
